import React from 'react'

class Archived extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
          <g fill="#979797" fillRule="nonzero">
            <g>
              <g>
                <path
                  d="M19.5 2.5c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1V17c0 1.105-.895 2-2 2h-13c-1.105 0-2-.895-2-2V7.5c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1zm-1.5 5H4V17c0 .245.177.45.41.492l.09.008h13c.245 0 .45-.177.492-.41L18 17V7.5zM13 10c.552 0 1 .448 1 1s-.448 1-1 1H9c-.552 0-1-.448-1-1s.448-1 1-1zm6-6H3v2h16V4z"
                  transform="translate(-613 -513) translate(328 500) translate(285 13)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

export default Archived
